import { convexClient } from "@convex-dev/better-auth/client/plugins";
import { lastLoginMethodClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

/**
 * Better Auth Client Integration
 * 
 * Configures the Better Auth React client with the official Convex plugin
 * and the lastLoginMethod client-side state plugin.
 */
export const authClient = createAuthClient({
  plugins: [
    convexClient(),
    lastLoginMethodClient(),
  ],
});

export const { signIn, signUp, signOut, useSession, updateUser } = authClient;
